import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TrustStrip } from '../components/sections/TrustStrip';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyUsSection } from '../components/sections/WhyUsSection';
import { WorkPreviewSection } from '../components/sections/WorkPreviewSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { CTASection } from '../components/sections/CTASection';
export function HomePage() {
  return <main data-id="element-327">
      <HeroSection data-id="element-328" />
      <TrustStrip data-id="element-329" />
      <ServicesSection data-id="element-330" />
      <WhyUsSection data-id="element-331" />
      <WorkPreviewSection data-id="element-332" />
      <ProcessSection data-id="element-333" />
      <TestimonialsSection data-id="element-334" />
      <CTASection data-id="element-335" />
    </main>;
}